import { Form, Button, Modal } from "react-bootstrap";
import { useState } from "react";

type WagerFormProps = {
  onSubmit: Function;
  show: boolean;
  onClose: Function;
};

export default function WagerCreationModal(props: WagerFormProps) {
  const [title, setTitle] = useState("");
  const [outcomes, setOutcomes] = useState<string[]>([]);

  return (
    <>
      <Modal show={props.show} onHide={() => props.onClose()}>
        <Modal.Header closeButton>
          <Modal.Title>Create Wager</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Control
              placeholder="Wager name"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
            />
            <Form.Control
              placeholder="TODO: Make less shit than a comma-separated list.."
              value={outcomes.join(",")}
              onChange={(e) => setOutcomes(e.target.value.split(","))}
            />
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={() => props.onClose()}>Close</Button>
          <Button
            className="mt-2"
            onClick={() => props.onSubmit({ title, outcomes })}
          >
            Submit
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
